"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _OldButtonStyles = require("./OldButton-styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Button(props) {
  let {
    children,
    onPress,
    ...styleProps
  } = props;
  return /*#__PURE__*/_react.default.createElement(_OldButtonStyles.Button, _extends({
    onPress: onPress
  }, styleProps), props.children);
}

var _default = Button;
exports.default = _default;